import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { PersonCareerRepresentationalStatisticResponse } from "~types/personCareerRepresentationalStatistic.ts";

type Props = {
  seasonId?: string;
  discipline?: string | null;
  representing?: string | null;
};

export const useFetchInternationalGamesAmount = ({ seasonId, discipline, representing }: Props) => {
  const request = useApi();
  const { sport, organizationId } = useParams();

  const isEnabled = !!sport && ["hockey", "football"].includes(sport) && !!discipline && !!representing;

  const params = new URLSearchParams({
    ...(seasonId && { seasonId }),
    ...(representing && { representing }),
    ...(discipline && { discipline }),
    limit: "1000",
  });

  return useQuery<Record<string, number>, unknown>({
    queryKey: ["international-games-amount", sport, organizationId, params.toString()],
    queryFn: () =>
      request<PersonCareerRepresentationalStatisticResponse>(
        `${sport}/o/${organizationId}/statistics/for/person/in/career/representing?${params}`,
      ).then((response) => {
        return response.data.reduce((acc, item) => {
          acc[item.personId] = item.statistics.games;
          return acc;
        }, {});
      }),
    enabled: isEnabled,
  });
};
